import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-02397391"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "cell-display-value"
};
const _hoisted_2 = {
  key: 2,
  class: "tax-editor"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "tax-brl-prefix"
}, "BRL", -1));
const _hoisted_4 = {
  key: 0,
  class: "tax-convert-bubble"
};
const _hoisted_5 = {
  class: "bubble-label"
};
const _hoisted_6 = {
  class: "bubble-amount"
};
const _hoisted_7 = {
  key: 1,
  class: "tax-convert-bubble"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "bubble-label"
}, "计算中...", -1));
const _hoisted_9 = [_hoisted_8];
import { ref, computed, nextTick, watch } from 'vue';
import { EditOutlined } from '@ant-design/icons-vue';
import { debounce } from 'lodash';
import dayjs from 'dayjs';
import { formatAmount } from '../hooks/useSettlementTable';
import { queryExchangeRate } from '@/api/billApi';
import { OK } from '@/common';
// rowKey → 编辑类型的内置映射
export default /*#__PURE__*/_defineComponent({
  __name: 'CellEditor',
  props: {
    rowKey: null,
    row: null,
    editable: {
      type: Boolean,
      default: false
    }
  },
  emits: ["save"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const keyTypeMap = {
      balance: 'amount',
      estimatedRevenue: 'amount',
      actualInvoiceAmount: 'amount',
      withholdingTax: 'tax',
      expectReceivedAmount: 'amount',
      actualReceivedAmount: 'payment',
      adjustment: 'amount',
      receivedDiff: 'amount',
      expectedReceiptTime: 'date',
      actualReceiptTime: 'date'
    };
    const cellType = computed(() => {
      var _keyTypeMap$props$row;
      return (_keyTypeMap$props$row = keyTypeMap[props.rowKey]) !== null && _keyTypeMap$props$row !== void 0 ? _keyTypeMap$props$row : 'text';
    });
    const rawValue = computed(() => props.row[props.rowKey]);
    const autoEditKeys = new Set(['actualReceiptTime']);
    const isPaymentAutoEdit = computed(() => (cellType.value === 'payment' || autoEditKeys.has(props.rowKey)) && props.editable);
    const isEditing = ref(isPaymentAutoEdit.value);
    const inputRef = ref(null);
    const originalRow = ref(isPaymentAutoEdit.value ? JSON.parse(JSON.stringify(props.row)) : {});
    // amount
    const sign = ref('+');
    const numValue = ref(null);
    // tax
    const taxBrlValue = ref(null);
    const taxConverted = ref(null);
    const taxConverting = ref(false);
    const taxConvertedDisplay = computed(() => {
      if (taxConverted.value === null) return '';
      return formatAmount(taxConverted.value);
    });
    // date
    const dateValue = ref(null);
    // text
    const textValue = ref('');
    const displayValue = computed(() => {
      const val = rawValue.value;
      if (val === null || val === undefined || val === '') return '-';
      if (cellType.value === 'amount' || cellType.value === 'tax') return formatAmount(val);
      return String(val);
    });
    const fetchConversion = async brlAmount => {
      taxConverting.value = true;
      try {
        var _props$row$currency;
        const res = await queryExchangeRate({
          fromCurrency: 'BRL',
          toCurrency: (_props$row$currency = props.row.currency) !== null && _props$row$currency !== void 0 ? _props$row$currency : 'USD',
          amount: String(brlAmount),
          rateSourceType: 1,
          rateDate: props.row.billMonth ? `${props.row.billMonth}-01` : dayjs().format('YYYY-MM-01')
        });
        if (res && res.code === OK && res.data) {
          taxConverted.value = res.data.convertedAmount;
        }
      } catch {
        taxConverted.value = null;
      } finally {
        taxConverting.value = false;
      }
    };
    const debouncedFetchConversion = debounce(fetchConversion, 500);
    const handleTaxChange = val => {
      taxConverted.value = null;
      if (val !== null && val > 0) {
        debouncedFetchConversion(val);
      } else {
        debouncedFetchConversion.cancel();
      }
    };
    const initValues = val => {
      if (cellType.value === 'amount') {
        const raw = val !== null && val !== undefined && val !== '' ? String(val) : null;
        const num = raw !== null ? Number(raw) : null;
        const isNegative = num !== null && num < 0 || raw !== null && raw.startsWith('-');
        sign.value = isNegative ? '-' : '+';
        numValue.value = num !== null ? Math.abs(num) : null;
      } else if (cellType.value === 'payment') {
        numValue.value = val !== null && val !== undefined && val !== '' ? Number(val) : null;
      } else if (cellType.value === 'tax') {
        taxBrlValue.value = null;
        const existing = val !== null && val !== undefined && val !== '' ? Number(val) : null;
        taxConverted.value = existing;
      } else if (cellType.value === 'date') {
        dateValue.value = val ? dayjs(String(val)) : null;
      } else {
        textValue.value = val ? String(val) : '';
      }
    };
    const startEdit = () => {
      originalRow.value = JSON.parse(JSON.stringify(props.row));
      initValues(rawValue.value);
      isEditing.value = true;
      nextTick(() => {
        var _inputRef$value;
        return (_inputRef$value = inputRef.value) === null || _inputRef$value === void 0 ? void 0 : _inputRef$value.focus();
      });
    };
    if (isPaymentAutoEdit.value) {
      initValues(rawValue.value);
    }
    watch(() => props.row, newRow => {
      if (isEditing.value) {
        initValues(newRow[props.rowKey]);
      }
    });
    const save = () => {
      if (!isEditing.value) return;
      debouncedFetchConversion.cancel();
      let result = null;
      if (cellType.value === 'amount') {
        result = numValue.value !== null ? sign.value === '-' ? -Math.abs(numValue.value) : Math.abs(numValue.value) : null;
      } else if (cellType.value === 'payment') {
        result = numValue.value;
      } else if (cellType.value === 'tax') {
        result = taxConverted.value;
      } else if (cellType.value === 'date') {
        result = dateValue.value ? dateValue.value.format('YYYY-MM-DD') : null;
      } else {
        result = textValue.value || null;
      }
      const original = originalRow.value[props.rowKey];
      const isEmpty = v => v === null || v === undefined || v === '';
      const isNumericType = cellType.value === 'amount' || cellType.value === 'payment' || cellType.value === 'tax';
      const unchanged = isEmpty(result) && isEmpty(original) || !isEmpty(result) && !isEmpty(original) && (isNumericType ? Number(result) === Number(original) : String(result) === String(original));
      if (unchanged) {
        if (!isPaymentAutoEdit.value) isEditing.value = false;
        return;
      }
      emit('save', props.rowKey, result, originalRow.value);
      taxBrlValue.value = null;
      taxConverted.value = null;
      if (!isPaymentAutoEdit.value) {
        isEditing.value = false;
      }
    };
    return (_ctx, _cache) => {
      var _props$row$currency2;
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_input_group = _resolveComponent("a-input-group");
      const _component_a_date_picker = _resolveComponent("a-date-picker");
      const _component_a_input = _resolveComponent("a-input");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["cell-editor", {
          'is-editing': isEditing.value,
          'is-editable': __props.editable
        }]),
        onClick: _cache[7] || (_cache[7] = $event => __props.editable && !isEditing.value && startEdit())
      }, [!isEditing.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [__props.editable ? (_openBlock(), _createBlock(_unref(EditOutlined), {
        key: 0,
        class: "cell-edit-icon"
      })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(displayValue)), 1)], 64)) : _unref(cellType) === 'amount' ? (_openBlock(), _createBlock(_component_a_input_group, {
        key: 1,
        compact: "",
        style: {
          "display": "flex",
          "width": "130px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_a_button, {
          size: "small",
          style: _normalizeStyle(sign.value === '+' ? {
            width: '26px',
            padding: 0,
            flexShrink: 0,
            color: '#52c41a',
            background: '#f6ffed',
            borderColor: '#b7eb8f'
          } : {
            width: '26px',
            padding: 0,
            flexShrink: 0,
            color: '#ff4d4f',
            background: '#fff2f0',
            borderColor: '#ffccc7'
          }),
          onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
          onClick: _cache[1] || (_cache[1] = $event => sign.value = sign.value === '+' ? '-' : '+')
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(sign.value), 1)]),
          _: 1
        }, 8, ["style"]), _createVNode(_component_a_input_number, {
          ref_key: "inputRef",
          ref: inputRef,
          value: numValue.value,
          "onUpdate:value": _cache[2] || (_cache[2] = $event => numValue.value = $event),
          precision: 2,
          controls: false,
          min: 0,
          size: "small",
          placeholder: "0.00",
          style: {
            "flex": "1",
            "min-width": "0"
          },
          onBlur: save,
          onPressEnter: save
        }, null, 8, ["value"])]),
        _: 1
      })) : _unref(cellType) === 'tax' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_a_input_number, {
        ref_key: "inputRef",
        ref: inputRef,
        value: taxBrlValue.value,
        "onUpdate:value": _cache[3] || (_cache[3] = $event => taxBrlValue.value = $event),
        precision: 2,
        controls: false,
        min: 0,
        size: "small",
        placeholder: "0.00",
        style: {
          "width": "150px"
        },
        onBlur: save,
        onPressEnter: save,
        onChange: handleTaxChange
      }, {
        addonBefore: _withCtx(() => [_hoisted_3]),
        _: 1
      }, 8, ["value"]), taxConverted.value !== null ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, "折合" + _toDisplayString((_props$row$currency2 = props.row.currency) !== null && _props$row$currency2 !== void 0 ? _props$row$currency2 : 'USD') + "：", 1), _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(taxConvertedDisplay)), 1)])) : taxConverting.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9)) : _createCommentVNode("", true)])) : _unref(cellType) === 'payment' ? (_openBlock(), _createBlock(_component_a_input_number, {
        key: 3,
        ref_key: "inputRef",
        ref: inputRef,
        value: numValue.value,
        "onUpdate:value": _cache[4] || (_cache[4] = $event => numValue.value = $event),
        precision: 2,
        controls: false,
        min: 0,
        size: "small",
        placeholder: "0.00",
        class: "payment-input",
        style: {
          "width": "110px"
        },
        onBlur: save,
        onPressEnter: save
      }, null, 8, ["value"])) : _unref(cellType) === 'date' ? (_openBlock(), _createBlock(_component_a_date_picker, {
        key: 4,
        ref_key: "inputRef",
        ref: inputRef,
        allowClear: false,
        value: dateValue.value,
        "onUpdate:value": _cache[5] || (_cache[5] = $event => dateValue.value = $event),
        format: "YYYY-MM-DD",
        size: "small",
        style: {
          "width": "130px"
        },
        onChange: save
      }, null, 8, ["value"])) : _unref(cellType) === 'text' ? (_openBlock(), _createBlock(_component_a_input, {
        key: 5,
        ref_key: "inputRef",
        ref: inputRef,
        value: textValue.value,
        "onUpdate:value": _cache[6] || (_cache[6] = $event => textValue.value = $event),
        size: "small",
        style: {
          "width": "120px"
        },
        onBlur: save,
        onPressEnter: save
      }, null, 8, ["value"])) : _createCommentVNode("", true)], 2);
    };
  }
});